import { Context } from "../Engine";
import { VertexBuffer } from "../Object/VertexBuffer";
import { RenderObject } from "../Object/RenderObject";
import { AnimationDataTexture, ITexture } from "../Texture";
import { Animation } from '@spi/Common/Animation';
import { Scene } from "../Scene";

export abstract class Mesh {

    public abstract buffer: VertexBuffer;
    public abstract texture: ITexture;
    public abstract dataLayout: MeshLayout;
    public animation: Animation;
    public animationDataTexture: AnimationDataTexture;

    public constructor(public reference: string, public ctx: Context, public scene: Scene) {

    }

    public abstract createInstance(ctx: Context): RenderObject;
}

export type MeshLayout = {
    position?: MeshLayoutSegment,
    normal?: MeshLayoutSegment,
    color?: MeshLayoutSegment,
    diffuseTexture?: MeshLayoutSegment,
    jointWeights?: MeshLayoutSegment,
    jointIndices?: MeshLayoutSegment,
    lightMap?: MeshLayoutSegment,
    staticLight?: MeshLayoutSegment
};

export type MeshLayoutSegment = {
    offset: number,
    length: number
}
